import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import { ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface CustomBasicContainerStyles {
    container?: InjectableCss;
    staticContent?: InjectableCss;
    ContentContainer?:InjectableCss;
}

export const CustomBasicContainerStyles: CustomBasicContainerStyles = {
    staticContent: {
        css: css`
            margin-left: -15px;
            p{
                font-size: 13px;
                &:last-child{
                    margin-bottom: 0
                }
            }
            h2{
                color: #3666b1;
                padding-bottom: 20px;
            }
            [class^="LazyImageStyle"]{
                width: 100%;
            } 
            [class^="Wrapper"]{
                [class^="GridWrapper"]{
                    padding: 30px;
                    &:nth-child(odd){
                        background-color: #F2F3F5;
                    }
                }
            }
        `
    },
};

const styles = CustomBasicContainerStyles;

const CustomBasicContainer: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="CommonCustomWrapper">
            <StyledWrapper {...styles.staticContent}>
                <Zone contentId={id} zoneName="staticContent" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CustomBasicContainer,
    definition: {
        displayName: "Custom Basic Container",
        group: "Common",
    },
};

export default widgetModule;
